const SampleCard = ({ka}) => {
    return(
        <div className="col-md-4">
        <div className="rounded bg-light" style={{border: '1px solid rgba(128,0,128,0.2)', overflow: 'hidden', marginBottom: '16px' }}>
            <h4 style={{ position: 'sticky', top: '0', backgroundColor: 'rgba(128,0,128,1)', padding: "8px", color: 'white'}} hidden={ka.subTitle === ''}>{ka.subTitle}</h4>
            <h6 style={{ margin: "8px"}}>{ka.title}</h6>
            <div className="rounded" style={{ height: '300px', overflowY: 'auto' }} >
                <p className="" style={{ margin: '8px'}}>{ ka.content }</p>
            </div>
            <img src={ka.img} alt=""  className="img-fluid" />
        </div>
        </div>
    )
};

export default SampleCard;

export const SampleCard2 = ({content, title, img, left}) => {
    return(
        <div className={`row mb-4 rounded ${left && 'flex-row-reverse bg-light border'}`} style={{ backgroundColor: `${!left && 'rgba(128, 0, 128, 0.05)'}`, border: `${!left && '1px solid rgba(128,0,128,0.1)'}` }}>
            <div className='col-md-6 d-flex align-items-cente p-md-5 rounded'>
            {title ? (
            <div>
                <h4 class="display-7 mb-2">{title}</h4>
                <p class="mb-3" style={{ height: '300px', overflowY: 'auto' }}>{content}</p>
            </div>
            ):(
                <p class="my-3" style={{ height: '300px', overflowY: 'auto' }}>{content}</p>
            )}
            </div>
            <div className='col-md-6 p-md-5'>
            <img src={img} className='img-fluid rounded mb-3' alt="" />
            </div>
        </div>
    )
}